import { pxToRem } from '../../utils';
import { breakpoints } from './breakpoints';

// TODO PXE-2946: move to shared ui package if we can unify breakpoints

// Returns a css expression that yields min for small and medium screens and max for large+ screens
// The center clamp value, ((100vw - 1339px) * max), will be negative or zero below the large breakpoint and >= max above the breakpoint
function getSpacingString(min: number, max: number) {
  return `clamp(${pxToRem(min)}, calc((100vw - ${
    breakpoints.values.lg - 1
  }px) * ${max}), ${pxToRem(max)})`;
}

// Spacing values -1 -> 5 are responsive and match designs
// All other spacing values will default to 8px times factor
function getSpacing(factor: number) {
  switch (factor) {
    case -1:
      return pxToRem(8);
    case 0:
      return getSpacingString(12, 16);
    case 1:
      return getSpacingString(16, 24);
    case 2:
      return getSpacingString(24, 40);
    case 3:
      return getSpacingString(40, 64);
    case 4:
      return getSpacingString(48, 80);
    case 5:
      return getSpacingString(64, 120);
    default:
      return factor * 8;
  }
}

export { getSpacing as spacing };
